import React from 'react';
import * as AiIcons from 'react-icons/ai';

import * as style from './Modal.module.css';

const Modal = ({ setOpenModal, title, body }) => {
  return (
    <div
      className={style.modalBackground}
      onClick={() => {
        setOpenModal(false);
      }}
      aria-hidden="true"
      role="presentation"
    >
      <div
        className={style.modalContainer}
        onClick={(e) => {
          e.stopPropagation();
        }}
        role="presentation"
      >
        <div className={style.titleCloseBtn}>
          <AiIcons.AiOutlineClose
            onClick={() => setOpenModal(false)}
            color="black"
            className={style.x}
          />
        </div>
        <div className={style.textContainer}>
          <div className={style.modalTitle}>
            <h2 className="lite">{title}</h2>
          </div>
          <div className={style.modalBody}>
            <p>{body}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
